var _rect, _path, _path2, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g, _path32, _path33, _g2, _path34, _path35, _g3, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _g4, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngryGorilla(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 101,
    fill: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-113 -301C-113 -302.105 -112.105 -303 -111 -303H2845C2846.1 -303 2847 -302.105 2847 -301V1395C2847 1396.1 2846.1 1397 2845 1397H-111C-112.105 1397 -113 1396.1 -113 1395V-301Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-111 -302H2845V-304H-111V-302ZM2846 -301V1395H2848V-301H2846ZM2845 1396H-111V1398H2845V1396ZM-112 1395V-301H-114V1395H-112ZM-111 1396C-111.552 1396 -112 1395.55 -112 1395H-114C-114 1396.66 -112.657 1398 -111 1398V1396ZM2846 1395C2846 1395.55 2845.55 1396 2845 1396V1398C2846.66 1398 2848 1396.66 2848 1395H2846ZM2845 -302C2845.55 -302 2846 -301.552 2846 -301H2848C2848 -302.657 2846.66 -304 2845 -304V-302ZM-111 -304C-112.657 -304 -114 -302.657 -114 -301H-112C-112 -301.552 -111.552 -302 -111 -302V-304Z",
    fill: "white",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_357_7023)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -16,
    y: -36,
    width: 478,
    height: 536,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_357_7023)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_357_7023)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 50.5C0 22.6096 22.6096 0 50.5 0C78.3904 0 101 22.6096 101 50.5C101 78.3904 78.3904 101 50.5 101C22.6096 101 0 78.3904 0 50.5Z",
    fill: "url(#paint0_radial_357_7023)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.527 64.0434C20.9146 59.3707 29.5607 34.685 29.5607 34.685C29.5607 34.685 35.3875 44.5807 36.5985 36.2247C36.5985 36.2247 37.1486 36.2247 33.7404 29.6281C30.3323 23.0315 42.9133 18.8065 40.1173 11.8158C39.017 9.0668 36.9289 7.63779 36.9289 7.63779C36.9289 7.63779 40.815 8.80348 43.5657 15.6131C44.0454 16.7989 45.0367 17.765 46.2879 18.0317C47.5324 18.2967 48.5153 17.6442 46.7357 13.4377C43.4986 5.78947 38.7302 4.83344 39.334 0.76613C39.9378 -3.30118 46.5361 -5.94116 46.5361 -5.94116C46.5361 -5.94116 41.5329 -1.21302 44.9411 1.92007C48.3492 5.05316 64.4574 13.1358 52.3075 24.4052C48.2385 28.0331 53.3524 30.2319 54.5617 30.0122C55.771 29.7925 60.0597 28.6385 58.8504 22.26C58.8504 22.26 69.6267 27.5383 62.7534 43.2071C62.7534 47.6601 68.1289 46.5968 68.4157 44.0859C68.4157 44.0859 67.8656 54.4211 62.5336 58.6545C57.4097 62.7218 52.5222 64.7177 48.5287 64.0418L48.527 64.0434Z",
    fill: "#FF781D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2101 29.4067C25.2101 29.4067 28.115 25.8426 25.3526 23.5749C22.5902 21.3073 26.3422 18.1323 27.4961 17.0186C28.6501 15.9049 27.9909 14.2142 27.0014 13.0603C27.0014 13.0603 31.3068 14.4273 28.2475 18.773C27.5112 19.8196 27.4978 21.2687 28.4035 22.1711C28.7004 22.4663 30.0221 23.5095 29.9499 25.7788C29.8778 28.0683 28.0949 29.2004 25.2084 29.4067H25.2101Z",
    fill: "#FF781D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2995 19.5613C60.2995 19.5613 58.8067 16.8593 60.5192 12.8205C60.9587 11.7823 58.9242 9.08861 59.3653 6.55933C59.3653 6.55933 59.6688 8.84709 63.8183 11.0124C65.3849 11.8309 60.5192 13.6239 60.2995 19.5613Z",
    fill: "#FF781D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4612 41.1508C67.7635 40.6107 67.3492 39.7888 67.3207 38.9066C67.2888 37.9019 67.4096 36.592 68.0922 35.641C69.3569 33.8816 67.3157 32.4241 67.3157 32.4241C67.3157 32.4241 70.5947 33.2208 69.6319 36.0519C68.6692 38.8831 67.4884 40.23 69.1925 41.7143L68.4612 41.1491V41.1508Z",
    fill: "#FF781D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2837 63.2283C35.1244 60.8315 39.5574 48.1734 39.5574 48.1734C39.5574 48.1734 42.5462 53.2487 43.1668 48.9634C43.1668 48.9634 43.4486 48.9634 41.7009 45.5804C39.9532 42.1974 46.4056 40.0304 44.9715 36.4461C44.408 35.0372 43.3362 34.3043 43.3362 34.3043C43.3362 34.3043 45.3288 34.903 46.7394 38.3934C46.9842 39.0022 47.4941 39.497 48.1365 39.6345C48.7755 39.7704 49.2787 39.4366 48.3663 37.2797C46.7058 33.3566 44.2604 32.8669 44.5707 30.7821C44.881 28.6956 48.264 27.342 48.264 27.342C48.264 27.342 45.6978 29.7673 47.4472 31.3741C49.1948 32.9809 57.4553 37.1254 51.2243 42.9052C49.1378 44.7652 51.7593 45.894 52.3799 45.78C53.0005 45.6676 55.1994 45.0755 54.5788 41.8049C54.5788 41.8049 60.1036 44.512 56.5797 52.546C56.5797 54.8287 59.3354 54.2836 59.483 52.9971C59.483 52.9971 59.2013 58.2972 56.4657 60.4676C53.8374 62.5541 51.3316 63.5772 49.2837 63.23V63.2283Z",
    fill: "#F2D351"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0537 61.8898C49.0537 61.8898 49.7397 60.5698 47.41 59.4981C44.1628 58.0036 47.7941 53.5455 49.2248 52.8176C50.4408 52.1987 51.4874 49.23 50.4978 48.076C50.4978 48.076 57.3325 52.6113 51.8228 55.684C50.7762 56.8178 52.9952 56.6753 53.3273 58.9412C53.4783 59.9727 51.9402 61.6835 49.0537 61.8898Z",
    fill: "#FFFF71"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7556 95.552C20.7556 95.552 22.6687 106.715 22.2528 114.62",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3284 90.4217C26.3284 90.4217 39.8505 94.4677 48.6583 86.1857",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9488 53.2627H25.8174C23.8487 53.2627 22.2527 54.8587 22.2527 56.8274V116.037C22.2527 118.006 23.8487 119.602 25.8174 119.602H72.9488C74.9175 119.602 76.5135 118.006 76.5135 116.037V56.8274C76.5135 54.8587 74.9175 53.2627 72.9488 53.2627Z",
    fill: "#4C4C4C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4039 122.008C19.4039 122.008 22.2527 119.373 22.2527 112.027C22.2527 104.681 20.6338 95.9441 20.6338 95.9441C20.6338 95.9441 6.49079 62.3259 10.0139 57.2076C13.537 52.0923 20.3308 55.1074 23.1825 53.3043C26.0343 51.5011 29.8931 48.7355 32.1567 38.7543C34.4203 28.7731 40.1654 21.3912 49.5108 21.3912V134.511L19.4039 122.008Z",
    fill: "#4C4C4C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6206 122.008C79.6206 122.008 76.7718 119.373 76.7718 112.027C76.7718 104.681 78.3908 95.9441 78.3908 95.9441C78.3908 95.9441 92.5337 62.3259 89.0106 57.2076C85.4875 52.0923 78.6938 55.1074 75.842 53.3043C72.9902 51.5041 69.1314 48.7355 66.8678 38.7543C64.6043 28.7731 58.8591 21.3912 49.5137 21.3912V134.511L79.6206 122.008Z",
    fill: "#4C4C4C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6002 91.4407C73.2322 91.4407 81.0406 86.5836 81.0406 80.5921C81.0406 74.6006 73.2322 69.7435 63.6002 69.7435C53.9682 69.7435 46.1599 74.6006 46.1599 80.5921C46.1599 86.5836 53.9682 91.4407 63.6002 91.4407Z",
    fill: "#878787"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7133 91.4407C43.3453 91.4407 51.1536 86.5836 51.1536 80.5921C51.1536 74.6006 43.3453 69.7435 33.7133 69.7435C24.0812 69.7435 16.2729 74.6006 16.2729 80.5921C16.2729 86.5836 24.0812 91.4407 33.7133 91.4407Z",
    fill: "#878787"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0414 108.783C58.7916 108.783 66.6956 104.829 66.6956 99.9514C66.6956 95.0739 58.7916 91.1199 49.0414 91.1199C39.2913 91.1199 31.3872 95.0739 31.3872 99.9514C31.3872 104.829 39.2913 108.783 49.0414 108.783Z",
    fill: "#878787"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9446 87.4066C49.9446 87.4066 61.821 95.0351 72.5745 89.5098",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7768 52.0625H12.8032C10.8345 52.0625 9.23853 53.6585 9.23853 55.6272V123.297C9.23853 125.266 10.8345 126.862 12.8032 126.862H86.7768C88.7455 126.862 90.3415 125.266 90.3415 123.297V55.6272C90.3415 53.6585 88.7455 52.0625 86.7768 52.0625Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.665 85.7045C24.389 85.7045 30.6505 79.0439 30.6505 70.8278C30.6505 62.6116 24.389 55.951 16.665 55.951C8.94097 55.951 2.67944 62.6116 2.67944 70.8278C2.67944 79.0439 8.94097 85.7045 16.665 85.7045Z",
    fill: "#4C4C4C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0297 99.9287C24.0325 89.8197 22.165 78.6935 14.8586 75.0777C7.55217 71.4618 -2.42643 76.7256 -7.42921 86.8347C-12.432 96.9437 -10.5645 108.07 -3.25807 111.686C4.04837 115.302 14.027 110.038 19.0297 99.9287Z",
    fill: "#4C4C4C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06194 129.032C10.1927 111.547 3.60925 96.8872 -5.64252 96.2889C-14.8943 95.6907 -23.311 109.38 -24.4417 126.865C-25.5724 144.351 -18.989 159.01 -9.73721 159.608C-0.48544 160.207 7.93123 146.517 9.06194 129.032Z",
    fill: "#4C4C4C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9794 98.0785C20.1916 92.7085 19.2366 87.2231 15.8462 85.8264C12.4559 84.4297 7.91411 87.6506 5.70188 93.0205C3.48965 98.3905 4.44469 103.876 7.83503 105.273C11.2254 106.669 15.7672 103.448 17.9794 98.0785Z",
    fill: "#565656"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6875 73.3532C28.8997 67.9832 27.138 62.1655 22.7525 60.3588C18.3671 58.5522 13.0186 61.4408 10.8064 66.8107C8.59415 72.1806 10.3559 77.9984 14.7413 79.805C19.1268 81.6117 24.4752 78.7231 26.6875 73.3532Z",
    fill: "#565656"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1784 85.7045C89.9024 85.7045 96.1639 79.0439 96.1639 70.8278C96.1639 62.6116 89.9024 55.951 82.1784 55.951C74.4544 55.951 68.1929 62.6116 68.1929 70.8278C68.1929 79.0439 74.4544 85.7045 82.1784 85.7045Z",
    fill: "#4C4C4C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M102.102 111.663C109.409 108.048 111.276 96.9214 106.273 86.8124C101.271 76.7033 91.292 71.4396 83.9856 75.0554C76.6791 78.6712 74.8117 89.7974 79.8144 99.9064C84.8172 110.015 94.7958 115.279 102.102 111.663Z",
    fill: "#4C4C4C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M108.584 159.601C117.835 159.002 124.419 144.343 123.288 126.858C122.157 109.372 113.741 95.6829 104.489 96.2812C95.2371 96.8795 88.6537 111.539 89.7844 129.024C90.9151 146.509 99.3318 160.199 108.584 159.601Z",
    fill: "#4C4C4C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8596 105.915C95.25 104.518 96.205 99.0328 93.9928 93.6629C91.7806 88.293 87.2388 85.072 83.8485 86.4687C80.4581 87.8654 79.5031 93.3509 81.7153 98.7208C83.9275 104.091 88.4693 107.312 91.8596 105.915Z",
    fill: "#565656"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9493 80.4478C89.3347 78.6412 91.0965 72.8234 88.8842 67.4535C86.672 62.0835 81.3235 59.1949 76.9381 61.0016C72.5527 62.8082 70.7909 68.626 73.0032 73.9959C75.2154 79.3659 80.5638 82.2545 84.9493 80.4478Z",
    fill: "#565656"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3795 58.8296C32.332 58.482 27.2909 49.1128 27.2909 49.1128L20.812 57.071L43.1657 86.8096L44.342 72.019L32.3795 58.8296Z",
    fill: "#EFEFEF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_357_7023",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 49,
    width: 25,
    height: 38
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3795 58.8296C32.332 58.482 27.2909 49.1128 27.2909 49.1128L20.812 57.071L43.1657 86.8096L44.342 72.019L32.3795 58.8296Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_357_7023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3481 47.283L32.5548 60.4249L43.3915 71.9448C43.3915 71.9448 41.6478 88.2711 41.9953 88.1612C42.3429 88.0513 45.7561 86.4353 45.7561 86.4353L45.6878 71.3299L33.345 59.3644L26.8572 46.4482L25.3481 47.2859V47.283Z",
    fill: "#E4E4F2"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6571 58.8296C66.7047 58.482 71.7458 49.1128 71.7458 49.1128L78.2246 57.071L55.8709 86.8096L54.6946 72.019L66.6571 58.8296Z",
    fill: "#EFEFEF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_357_7023",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 49,
    width: 25,
    height: 38
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6571 58.8296C66.7047 58.482 71.7458 49.1128 71.7458 49.1128L78.2246 57.071L55.8709 86.8096L54.6946 72.019L66.6571 58.8296Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_357_7023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.9558 47.3305L66.7491 60.4724L55.9124 71.9923C55.9124 71.9923 57.6562 88.3186 57.3086 88.2087C56.961 88.0988 53.5479 86.4828 53.5479 86.4828L53.6162 71.3774L65.959 59.4118L72.4467 46.4957L73.9558 47.3334V47.3305Z",
    fill: "#E4E4F2"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3451 79.9445C56.7323 78.5572 56.7323 76.2907 55.3451 74.9034L52.3091 71.8675C50.9219 70.4802 48.6553 70.4802 47.268 71.8675L44.2321 74.9034C42.8448 76.2907 42.8448 78.5572 44.2321 79.9445L47.268 82.9804C47.4789 83.1914 47.7106 83.3636 47.9542 83.5122L44.4222 108.545L49.7871 122.076L55.152 108.545L51.62 83.5122C51.8635 83.3666 52.0952 83.1914 52.3062 82.9804L55.3421 79.9445H55.3451Z",
    fill: "#383866"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_357_7023",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 70,
    width: 14,
    height: 53
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3451 79.9445C56.7323 78.5572 56.7323 76.2907 55.3451 74.9034L52.3091 71.8675C50.9219 70.4802 48.6553 70.4802 47.268 71.8675L44.2321 74.9034C42.8448 76.2907 42.8448 78.5572 44.2321 79.9445L47.268 82.9804C47.4789 83.1914 47.7106 83.3636 47.9542 83.5122L44.4222 108.545L49.7871 122.076L55.152 108.545L51.62 83.5122C51.8635 83.3666 52.0952 83.1914 52.3062 82.9804L55.3421 79.9445H55.3451Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_357_7023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.7902 69.9871C49.7902 69.9871 50.1853 71.4129 48.1712 73.5518C46.1571 75.6906 44.5916 77.8175 46.4364 80.1643C48.2811 82.5111 49.2881 81.6021 48.7 84.4627C48.1118 87.3234 45.1501 106.95 45.8215 108.795C46.4928 110.64 49.0654 120.76 50.3516 121.152C51.6379 121.545 50.5803 124.004 50.1021 123.948C49.6238 123.891 43.1925 107.396 43.1925 107.396L46.1304 84.4627L42.5984 77.464L46.4394 71.0119L49.7902 69.9871Z",
    fill: "#1A1A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0212 83.5477L50.221 85.1132L47.9544 83.5121L47.7168 85.2113L48.703 84.4627L50.221 85.4757L52.0212 83.5477Z",
    fill: "#070723"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6414 53.2626C58.6533 53.2626 65.9589 48.9256 65.9589 43.5755C65.9589 38.2255 58.6533 33.8884 49.6414 33.8884C40.6295 33.8884 33.324 38.2255 33.324 43.5755C33.324 48.9256 40.6295 53.2626 49.6414 53.2626Z",
    fill: "#4C4C4C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3815 45.2926H35.2698C33.3011 45.2926 31.7051 46.8886 31.7051 48.8573V57.7483C31.7051 59.717 33.3011 61.313 35.2698 61.313H64.3815C66.3503 61.313 67.9463 59.717 67.9463 57.7483V48.8573C67.9463 46.8886 66.3503 45.2926 64.3815 45.2926Z",
    fill: "#4C4C4C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6415 77.1759C57.0505 77.1759 63.0567 68.8648 63.0567 58.6126C63.0567 48.3605 57.0505 40.0494 49.6415 40.0494C42.2325 40.0494 36.2263 48.3605 36.2263 58.6126C36.2263 68.8648 42.2325 77.1759 49.6415 77.1759Z",
    fill: "#4C4C4C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5138 51.5575C57.9695 51.5575 64.8242 44.8039 64.8242 36.4729C64.8242 28.1419 57.9695 21.3882 49.5138 21.3882C41.0581 21.3882 34.2034 28.1419 34.2034 36.4729C34.2034 44.8039 41.0581 51.5575 49.5138 51.5575Z",
    fill: "#4C4C4C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4679 55.4877L68.0293 56.7472C68.0293 56.7472 63.9418 76.0738 49.8731 80.3456L47.7046 72.5329L67.4679 55.4906V55.4877Z",
    fill: "#4C4C4C"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M32.308 55.5292L31.7466 56.7887C31.7466 56.7887 32.614 72.3902 49.8731 80.3455L50.7257 74.2112L32.308 55.5351V55.5292Z",
    fill: "#4C4C4C"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2643 46.3174C38.2643 46.2046 37.486 42.0368 40.7209 42.3517C44.1342 42.6844 50.3278 43.3498 50.3278 43.3498C50.3278 43.3498 59.1475 42.1824 59.9317 42.3339C60.716 42.4854 62.3914 43.1864 61.0784 46.0085C59.7654 48.8306 38.1811 50.0901 38.2643 46.3174Z",
    fill: "#8E8E8E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4822 46.3174C61.4822 46.2046 62.2605 42.0368 59.0255 42.3517C55.6123 42.6844 49.4186 43.3498 49.4186 43.3498C49.4186 43.3498 40.599 42.1824 39.8147 42.3339C39.0305 42.4854 37.3551 43.1864 38.6681 46.0085C39.9811 48.8306 61.5654 50.0901 61.4822 46.3174Z",
    fill: "#8E8E8E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5433 45.7709H42.1111C40.1424 45.7709 38.5464 47.3668 38.5464 49.3356V49.3772C38.5464 51.3459 40.1424 52.9419 42.1111 52.9419H57.5433C59.512 52.9419 61.108 51.3459 61.108 49.3772V49.3356C61.108 47.3668 59.512 45.7709 57.5433 45.7709Z",
    fill: "#383838"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7402 55.0984C36.7402 55.0984 38.9236 56.4827 40.9585 55.5648",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5793 51.7001C41.5793 51.7001 43.7627 53.0844 45.7976 52.1665",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5188 52.3684C40.5188 52.3684 42.3932 54.1478 44.5677 53.6398",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9358 47.5858L46.466 49.3147L40.9585 50.3514",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1121 49.1127L46.4658 49.3147",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M63.146 55.0984C63.146 55.0984 60.9626 56.4827 58.9277 55.5648",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3098 51.7001C58.3098 51.7001 56.1264 53.0844 54.0916 52.1665",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3702 52.3684C59.3702 52.3684 57.4958 54.1478 55.3213 53.6398",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9533 47.5858L53.4202 49.3147L58.9276 50.3514",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7769 49.1127L53.4202 49.3147",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9446 55.951C53.6311 55.951 56.1412 53.8478 56.1412 58.8354C56.1412 63.8231 56.1413 76.252 49.909 76.252C42.7142 76.252 43.6885 63.6003 43.6885 58.6126C43.6885 53.625 46.2581 55.951 49.9446 55.951Z",
    fill: "#8E8E8E"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0261 66.5085C13.0261 66.5085 13.0618 67.0937 20.0486 65.3054C27.0354 63.5171 26.6789 66.1163 26.6789 66.1163",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9862 59.7444C52.8914 59.7444 54.8698 58.0868 54.8698 62.0169C54.8698 65.947 54.8698 75.744 49.9565 75.744C44.2856 75.744 45.052 65.7717 45.052 61.8387C45.052 57.9056 47.078 59.7414 49.9832 59.7414L49.9862 59.7444Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_357_7023)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_357_7023",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 59,
    width: 10,
    height: 17
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9862 59.7444C52.8914 59.7444 54.8698 58.0868 54.8698 62.0169C54.8698 65.947 54.8698 75.744 49.9565 75.744C44.2856 75.744 45.052 65.7717 45.052 61.8387C45.052 57.9056 47.078 59.7414 49.9832 59.7414L49.9862 59.7444Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_357_7023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9446 73.3318C48.8306 73.3318 48.2216 72.4288 48.2216 71.3118L47.9246 67.759C47.9246 66.645 48.8276 65.739 49.9446 65.739C51.0585 65.739 51.9646 66.6421 51.9646 67.759L51.6675 71.3118C51.6675 72.4258 51.0615 73.3318 49.9446 73.3318Z",
    fill: "url(#paint1_radial_357_7023)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9036 57.8046H44.342V61.2564H55.9036V57.8046Z",
    fill: "#450025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9036 73.9141H44.342V77.3659H55.9036V73.9141Z",
    fill: "#450025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1366 60.496C49.5821 60.496 49.9416 60.8584 49.9416 61.301V62.0971C49.9416 62.2189 49.8436 62.3169 49.7218 62.3169H48.5514C48.4296 62.3169 48.3315 62.2189 48.3315 62.0971V61.301C48.3315 60.8554 48.6939 60.496 49.1366 60.496Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7137 60.6891C48.0613 60.6891 48.3405 60.9713 48.3405 61.3159V62.1506C48.3405 62.2457 48.2633 62.3229 48.1682 62.3229H47.2592C47.1642 62.3229 47.0869 62.2457 47.0869 62.1506V61.3159C47.0869 60.9683 47.3691 60.6891 47.7137 60.6891Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.63 62.3199H51.721C51.6259 62.3199 51.5487 62.2427 51.5487 62.1476V61.3129C51.5487 60.9654 51.8309 60.6861 52.1755 60.6861C52.523 60.6861 52.8022 60.9683 52.8022 61.3129V62.1476C52.8022 62.2427 52.725 62.3199 52.63 62.3199Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7496 60.496C51.1952 60.496 51.5546 60.8584 51.5546 61.301V62.0971C51.5546 62.2189 51.4566 62.3169 51.3348 62.3169H50.1644C50.0426 62.3169 49.9446 62.2189 49.9446 62.0971V61.301C49.9446 60.8554 50.307 60.496 50.7496 60.496Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8017 63.4012L46.5908 64.0933C46.5582 64.2062 46.4393 64.2032 46.4066 64.0933L46.1957 63.3774C46.0888 63.012 46.0175 62.6288 45.9848 62.2397L45.9165 61.4168C45.9165 60.9742 46.1809 60.6147 46.5047 60.6147C46.8285 60.6147 47.0929 60.9742 47.0929 61.4168L47.0245 62.2129C46.9889 62.6229 46.9146 63.0239 46.7988 63.4041L46.8017 63.4012Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0846 63.4012L53.2955 64.0933C53.3282 64.2062 53.447 64.2032 53.4797 64.0933L53.6906 63.3774C53.7975 63.012 53.8688 62.6288 53.9015 62.2397L53.9698 61.4168C53.9698 60.9742 53.7054 60.6147 53.3816 60.6147C53.0579 60.6147 52.7935 60.9742 52.7935 61.4168L52.8618 62.2129C52.8974 62.6229 52.9717 63.0239 53.0876 63.4041L53.0846 63.4012Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8308 73.3348H49.7487C49.8438 73.3348 49.921 73.4121 49.921 73.5071V74.131C49.921 74.4785 49.6388 74.7637 49.2883 74.7637C48.9407 74.7637 48.6555 74.4815 48.6555 74.131V73.5071C48.6555 73.4121 48.7328 73.3348 48.8278 73.3348H48.8308Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8147 73.3348H48.5276C48.6019 73.3348 48.6613 73.3943 48.6613 73.4685V74.122C48.6613 74.3924 48.4415 74.6152 48.1682 74.6152C47.8979 74.6152 47.675 74.3953 47.675 74.122V73.4685C47.675 73.3943 47.7345 73.3348 47.8087 73.3348H47.8147Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6735 74.6151C51.4031 74.6151 51.1804 74.3953 51.1804 74.122V73.4685C51.1804 73.3942 51.2398 73.3348 51.314 73.3348H52.027C52.1012 73.3348 52.1606 73.3942 52.1606 73.4685V74.122C52.1606 74.3923 51.9408 74.6151 51.6675 74.6151H51.6735Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0962 73.3348H51.0141C51.1091 73.3348 51.1864 73.4121 51.1864 73.5071V74.131C51.1864 74.4785 50.9042 74.7637 50.5536 74.7637C50.2061 74.7637 49.9209 74.4815 49.9209 74.131V73.5071C49.9209 73.4121 49.9981 73.3348 50.0932 73.3348H50.0962Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4583 72.4882L47.2919 71.9446C47.2652 71.8585 47.1731 71.8585 47.1493 71.9446L46.9859 72.5061C46.9028 72.7912 46.8463 73.0913 46.8196 73.4002L46.7661 74.0478C46.7661 74.3953 46.9741 74.6776 47.2266 74.6776C47.482 74.6776 47.687 74.3953 47.687 74.0478L47.6335 73.424C47.6068 73.1031 47.5474 72.7883 47.4553 72.4912L47.4583 72.4882Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3864 72.4882L52.5528 71.9446C52.5795 71.8585 52.6716 71.8585 52.6954 71.9446L52.8588 72.5061C52.9419 72.7912 52.9984 73.0913 53.0251 73.4002L53.0786 74.0478C53.0786 74.3953 52.8707 74.6776 52.6182 74.6776C52.3627 74.6776 52.1577 74.3953 52.1577 74.0478L52.2112 73.424C52.2379 73.1031 52.2973 72.7883 52.3894 72.4912L52.3864 72.4882Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9446 67.6401V72.1138",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3125 54.142H52.5764C54.5459 54.142 56.1411 55.2946 56.1411 56.7145V56.7442C56.1411 58.1641 51.8902 59.5306 49.9236 59.5306C47.9541 59.5306 43.7478 58.1641 43.7478 56.7442V56.7145C43.7478 55.2946 45.343 54.142 47.3125 54.142Z",
    fill: "#8E8E8E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4932 54.947H51.9911C51.8901 54.947 51.7921 54.9648 51.7 54.9886H51.6822C51.6822 54.9886 51.6525 54.9975 51.5931 55.0213C51.4921 55.0569 51.397 55.1045 51.3109 55.1639C51.0257 55.3302 50.5712 55.6481 49.9444 56.2511C49.9444 56.2511 48.5839 54.9916 48.0818 54.9678C48.0699 54.9678 48.061 54.9678 48.0492 54.9678C47.9838 54.9559 47.9214 54.947 47.8531 54.947H47.3511C46.6946 54.947 46.1628 55.4788 46.1628 56.1353C46.1628 56.7918 46.6946 57.3235 47.3511 57.3235H47.6036L52.2407 57.3591V57.3235H52.4932C53.1497 57.3235 53.6814 56.7918 53.6814 56.1353C53.6814 55.4788 53.1497 54.947 52.4932 54.947Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4493 42.3458L50.7317 43.2756C49.9237 43.3736 49.1038 43.3736 48.2958 43.2756L40.5188 42.3458C40.5188 42.3458 37.8601 42.1319 37.6284 43.9113",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6733 40.3762H58.6068",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7052 51.5575C31.7052 51.5575 29.1475 70.7237 49.8733 80.3455",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8616 45.6876C33.8616 45.6876 29.3523 47.7136 32.4536 52.9418",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0741 54.7272C68.0741 54.7272 66.1432 73.9172 49.8733 80.3455",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3916 45.6876C65.3916 45.6876 69.901 47.7136 66.7997 52.9418",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2073 57.1333C43.2073 57.1333 39.5535 63.027 39.9872 65.8312",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4292 33.8855C34.4292 33.8855 33.8499 36.3689 34.2183 39.4643",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82444 61.313C7.82444 61.313 -0.564501 66.4729 0.106852 80.1168C0.778205 93.7607 7.82444 61.313 7.82444 61.313Z",
    fill: "#4C4C4C"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1287 61.313C91.1287 61.313 99.5176 66.4729 98.8462 80.1168C98.1749 93.7607 91.1287 61.313 91.1287 61.313Z",
    fill: "#4C4C4C"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93266 58.7998C8.93266 58.7998 -0.338545 65.8045 1.17943 78.5513",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M4.34302 83.4677C4.34302 83.4677 4.9312 85.3748 11.8913 84.3677",
    stroke: "#4C4C4C",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7642 84.6618C17.7642 84.6618 21.3229 85.1104 29.4831 76.7838",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6527 85.7045C21.6527 85.7045 23.1142 94.6667 16.2729 105.397",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M-14.2646 100.569C-14.2646 100.569 -7.95215 93.8468 0.0684397 93.5111",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0356 58.7998C90.0356 58.7998 99.3068 65.8045 97.7889 78.5513",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7707 83.4677C94.7707 83.4677 94.1825 85.3748 87.2224 84.3677",
    stroke: "#4C4C4C",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M101.386 79.9832C101.386 79.9832 106.745 85.1876 108.456 93.3746",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3496 84.6618C81.3496 84.6618 77.7908 85.1104 69.6306 76.7838",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4581 85.7045C77.4581 85.7045 75.9966 94.6667 82.8379 105.397",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M114.617 101.264C114.617 101.264 108.305 94.542 100.284 94.2063",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3108 33.0567C40.3108 33.0567 44.128 31.1288 46.1688 32.7061",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0715 29.296C44.0715 29.296 48.768 31.0308 52.1248 29.296C55.4816 27.5612 58.4492 28.6811 58.4492 28.6811",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6982 38.6206C63.6982 38.6206 65.8103 40.299 65.9559 43.4567",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6582 92.7833V103.644",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91113 101.184C2.91113 101.184 6.27978 106.317 6.58872 108.783",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2947 51.8784C47.2947 51.8784 49.9236 50.4288 52.5496 51.8784",
    stroke: "#8E8E8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2947 50.9961C47.2947 50.9961 49.9236 49.5464 52.5496 50.9961",
    stroke: "#8E8E8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2412 53.0132C47.2412 53.0132 49.8702 51.5635 52.4962 53.0132",
    stroke: "#8E8E8E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_357_7023",
    x: -66,
    y: -71,
    width: 578,
    height: 636,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_357_7023"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_357_7023",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_357_7023",
    x: 45.0173,
    y: 59.3135,
    width: 9.85254,
    height: 20.4305,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_357_7023"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_357_7023",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.5 50.5) scale(45.45 68.2837)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48529,
    stopColor: "#D1AE1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647959,
    stopColor: "#FF3D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D234E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_357_7023",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.903 71.1347) scale(3.03891 6.01705)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#B9001D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_357_7023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 478,
    height: 101,
    fill: "white",
    transform: "translate(-16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_357_7023"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 50.5C0 22.6096 22.6096 0 50.5 0C78.3904 0 101 22.6096 101 50.5C101 78.3904 78.3904 101 50.5 101C22.6096 101 0 78.3904 0 50.5Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngryGorilla);
export default __webpack_public_path__ + "static/media/Angry-Gorilla.f2cb92d49f97ba4a558f1f5aa3917057.svg";
export { ForwardRef as ReactComponent };